import React from 'react';
import PropTypes from 'prop-types';
import { nameToBannerUrl } from '../../utils/url';

const WeatherbysOverview = ({
        data: {
            externalLinks: { weatherbysDomain, assetsUrl },
            profile: { weatherbysUid, horseName },
        },
    }) => {
    const mainFrameUrl = `${weatherbysDomain}/pages/${weatherbysUid}rpdynover.html`;
    const bannerFrameUrl = `${weatherbysDomain}/pages/images/${nameToBannerUrl(horseName)}con.jpg`;
    const logoUrl = `${assetsUrl}/img/png/weatherbys_logo.png`;

    return (
        <section className="hp-weatherbysOverview__container">
            <iframe
                className="hp-weatherbysOverview__mainFrame"
                src={mainFrameUrl}
                scrolling="no"
            />
            <div className="hp-weatherbysOverview__bannerContainer">
                <img src={logoUrl} alt="weatherbys" />
                <img
                    className="hp-weatherbysOverview__banner"
                    src={bannerFrameUrl}
                    alt={`weatherbys fee banner for ${horseName}`}
                />
            </div>
        </section>
    );
};

WeatherbysOverview.propTypes = {
    data: PropTypes.shape({
        externalLinks: PropTypes.shape({
            weatherbysDomain: PropTypes.string.isRequired,
            assetsUrl: PropTypes.string.isRequired,
        }).isRequired,
        profile: PropTypes.shape({
            weatherbysUid: PropTypes.string.isRequired,
            horseName: PropTypes.string.isRequired,
        }).isRequired,
    }).isRequired,
};

export default WeatherbysOverview;



// WEBPACK FOOTER //
// ./src/js/horse/weatherbysOverview/WeatherbysOverview.jsx